<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'DistributorOrderList' }">
          待办订单
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="rj-breadcrumb__tip" />
    </div>
    <do-it-action-box v-if="baseInfo" :base-info="baseInfo" />
    <base-info :document-i-d="documentID" @initedBaseInfo="initedBaseInfo" />
    <rj-tabs v-model="tabsActive">
      <rj-tab-pane name="1" label="分销商产品及价格">
        <distributor-product :document-i-d="documentID" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="集成商产品及价格">
        <integrators-product :document-i-d="documentID" />
      </rj-tab-pane>
    </rj-tabs>
  </div>
</template>
<script type="es6">
import baseInfo from './baseInfo';
import doItActionBox from './doItActionBox';
import distributorProduct from './distributorProduct';
import integratorsProduct from './integratorsProduct';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
import { getIsCurrentApprover } from '@/API';
export default {
  data () {
    return {
      tabsActive: '1',
      baseInfo: null
    };
  },
  props: {
    documentID: {
      type: String,
      required: true
    }
  },
  components: {
    baseInfo,
    doItActionBox,
    distributorProduct,
    integratorsProduct,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs
  },
  computed: {},
  methods: {
    initedBaseInfo (val) {
      this.baseInfo = val;
    },
    isLimit () {
      getIsCurrentApprover(this.documentID).then((res) => {
        let json = res.data;
        if (json.status !== '200') {
          this.$router.push({ name: 'DistributorOrderList' });
        }
      }).catch((res) => {

      });
    }
  },
  mounted () {
    this.isLimit();
  }
};
</script>
<style lang="scss"></style>
